import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '@/environments/environment';
import {
  LoginResponseDto,
  SigninSubmitRequest,
} from 'sham-components/shared/models/auth';

@Injectable({ providedIn: 'root' })
export class SigninApi {
  private readonly http = inject(HttpClient);

  login(payload: SigninSubmitRequest): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${API_BASE_URL}/api/v1/auth/login`,
      payload,
    );
  }

  refreshToken(payload: {
    refreshToken: string;
  }): Observable<LoginResponseDto> {
    return this.http.post<LoginResponseDto>(
      `${API_BASE_URL}/api/v1/auth/refresh-token`,
      payload,
    );
  }
}
